
export default function filtersToEndPoint(filters, filtersConfig) {
    return filters.reduce(((result, item) => {
        if (item instanceof Array) {
            return result.concat([filtersToEndPoint(item, filtersConfig)]);
        }

        const type = filtersConfig[item.field].type;
        const rules = filtersConfig[item.field].rules;

        return result.concat(itemToEndpoint(item.field, item.operator, item.value, type, rules));
    }), []);
}

function itemToEndpoint(field, operator, value, type, rules) {
    var operatorValuePairs = [[operator, value]];

    switch (type) {
        case 'string':
            switch (operator) {
                case 'contain':
                    operatorValuePairs = [['LIKE', '%' + value + '%']];
                    break;
                case 'not_contain':
                    operatorValuePairs = [['NOT LIKE', '%' + value + '%']];
                    break;
                case 'start_with':
                    operatorValuePairs = [['LIKE', value + '%']];
                    break;
                case 'not_start_with':
                    operatorValuePairs = [['NOT LIKE', value + '%']];
                    break;
                case 'end_with':
                    operatorValuePairs = [['LIKE', '%' + value]];
                    break;
                case 'not_end_with':
                    operatorValuePairs = [['NOT LIKE', '%' + value]];
                    break;
            }
            break;
        case 'number':
            if (operator === 'is') {
                switch (value) {
                    case 'empty':
                        operatorValuePairs = [['=', 'null']];
                        break;
                    case 'not_empty':
                        operatorValuePairs = [['!=', 'null']];
                        break;
                }
            }
            else if (!rules || rules.decimalDigits === undefined) { // is integer
                switch (operator) {
                    case 'in_range':
                        operatorValuePairs = [
                            ['>=', value[0]],
                            ['<=', value[1]]
                        ];
                        break;
                    case 'in_list':
                        operatorValuePairs = [['IN', value]];
                        break;
                }
            }
            else { // is decimal
                var getBound = (value) => {
                    if (value instanceof Array) {
                        return value.map(v => getBound(v));
                    }
                    var agent = Math.pow(10, rules.decimalDigits);
                    var agent10 = agent * 10;
                    var middle = Math.round(value * agent) / agent;
                    var delta = 5 / agent10;
                    return {
                        left: Math.round((middle - delta) * agent10) / agent10,
                        right: Math.round((middle + delta) * agent10) / agent10
                    };
                };
                var bound = getBound(value);
                switch (operator) {
                    case '=':
                        operatorValuePairs = [
                            ['>=', bound.left],
                            ['<', bound.right]
                        ];
                        break;
                    case '!=':
                        // cannot support because of api does not have OR operator, only AND
                        break;
                    case '>':
                        operatorValuePairs = [['>=', bound.right]];
                        break;
                    case '<':
                        operatorValuePairs = [['<', bound.left]];
                        break;
                    case '>=':
                        operatorValuePairs = [['>=', bound.left]];
                        break;
                    case '<=':
                        operatorValuePairs = [['<', bound.right]];
                        break;
                    case 'in_range':
                        operatorValuePairs = [
                            ['>=', bound[0].left],
                            ['<', bound[1].right]
                        ];
                        break;
                }
            }
            break;
        case 'selectable':
            switch (operator) {
                case 'in_list':
                    operatorValuePairs = [['IN', value]];
                    break;
                case 'is':
                    operatorValuePairs = [['=', value]];
                    break;
            }
            break;
    }

    return operatorValuePairs.map(function (pair) {
        return [field, pair[0], pair[1]];
    });
}
